import React from "react";

import classNames from "classnames";

const Square = ({ children, className: _className }) => {
  return (
    <div
      className={classNames("relative w-full", _className)}
      style={{ paddingBottom: "100%" }}
    >
      <div className={classNames("absolute inset-0 z-10 flex flex-col", {})}>
        {children}
      </div>
    </div>
  );
};

Square.defaultProps = {};

export default Square;
